import { defaultPageJson } from "../config/defaultValues"
import { HTTP_REST_URLS } from "../config/urls"

export const useSinglePage = (slug) => new Promise((resolve, reject) => {

    const url = HTTP_REST_URLS.GET_PAGES + `?slugs=${slug}`

    fetch(url, {
        method: 'GET'
    })
        .then((res) => (res.json()))
        .then((response) => {

            if(!response?.error)
            {
                resolve(response)
            }
            else
            {
                resolve(defaultPageJson)
            }

        })
        .catch((error) => {
            resolve(defaultPageJson)
        })

})